
import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-select',
    label: '影片分類',
    model: 'category_id',
    required: true,
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/maternity-qa-categories-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-upload",
    label: "封面截圖",
    model: "cover_img",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "maternity_qa_videos",
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '描述',
    model: 'description',
    placeholder: '描述',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '影片網址',
    model: 'video_url',
    placeholder: '影片網址',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '是否顯示',
    model: 'is_show',
    required: true,
    textOn: '是',
    textOff: '否',
    valueOn: 1,
    valueOff: 0,
  },
  {
    type: 'bsx-input',
    inputType: 'number',
    label: '權重',
    model: 'sort',
    required: true,
    validator: function () {
      this.validation();
    },
  },
];

export default fields;
